var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#D33B4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3899 11.6621C22.7592 10.0181 20.4985 9 18 9C13.0294 9 9 13.0294 9 18C9 20.4985 10.0181 22.7592 11.6621 24.3899M24.3899 11.6621C26.0033 13.2887 27 15.5279 27 18C27 22.9706 22.9706 27 18 27C15.5279 27 13.2887 26.0033 11.6621 24.3899M24.3899 11.6621L11.6621 24.3899",
    stroke: "#FFA8A8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageError);
export default __webpack_public_path__ + "static/media/message-error.8a22c9feb7221a052c29dfbd189dd4b2.svg";
export { ForwardRef as ReactComponent };